































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ToastApi } from '@/services/api/api.toasts';
import { ValidationObserver } from 'vee-validate/dist/types/components/Observer';
import { ApiPermissions } from '@/core/security/Permissions';
import { actionOptions } from '@/core/actions/WebsiteActions.vue';
import { HomeRoutes } from '@/router/home/home.routes';
import { Toast } from '@/types/apiServerContract';

@Component
export default class CreateToast extends Vue {
	@Prop({ required: true, type: Array }) toasts!: Toast[];

	permissions: string[] = [ApiPermissions.Toast.Create];

	loading: boolean = false;
	toast: Toast = {
	    id: '',
	    title: '',
	    subtitle: '',
	    clickUrl: '',
	    action: 0,
	    duration: 5000,
	    from: new Date(),
	    to: new Date()
	};

	get actionOptions(): any[] {
	    return actionOptions;
	}

	get clickUrlOptions() {
	    return Object.values(HomeRoutes.children!)
	        .map(x => x.path)
	        .sort((a, b) => (a > b ? 1 : -1));
	}

	async CreateToast() {
	    if (this.toast.from >= this.toast.to) {
	        this.$bvToast.toast('Please select a valid timespan', {
	            variant: 'danger',
	            title: 'Wrong Timespan'
	        });
	        return;
	    }

	    this.loading = true;

	    try {
	        await ToastApi.SaveToast(this.toast);
	    } finally {
	        this.loading = false;
	    }

	    this.$bvToast.toast('Toast edited successfully', {
	        variant: 'success',
	        title: 'Success'
	    });

	    this.$emit('update', this.toast);

	    this.Reset();
	    this.$nextTick(() => {
	        this.$refs.validator.reset();
	    });
	}

	currentIndex: number = 0;

	Next() {
	    if (this.currentIndex >= this.toasts.length - 1) return;

	    this.SetDefaultToast(++this.currentIndex);
	}

	Prev() {
	    if (this.currentIndex <= 0) return;

	    this.SetDefaultToast(--this.currentIndex);
	}

	Reset() {
	    this.SetDefaultToast(this.currentIndex);
	}

	SetDefaultToast(index: number = 0) {
	    const toast = this.toasts[index];
	    this.toast = {
	        id: toast.id,
	        title: toast.title,
	        subtitle: toast.subtitle,
	        duration: toast.duration,
	        clickUrl: toast.clickUrl,
	        action: toast.action,
	        from: new Date(toast.from),
	        to: new Date(toast.to)
	    };
	}

	public $refs!: {
		validator: InstanceType<typeof ValidationObserver>;
	};

	created() {
	    this.Reset();
	}
}
